import { CompactToolbar } from '../../core/slots/toolbar/CompactToolbar.js';
import { DISPLAY_NAME } from '../defaults.js';

export const SingleValueGridToolbarSlot = CompactToolbar(DISPLAY_NAME);
